import React from 'react';
import './DetailModal.css';
import { FaEdit } from 'react-icons/fa';

const DetailModal = ({ data, type, onClose, onEdit }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        
        {/* Кнопка редактирования - для тестов и групп */}
        <button 
          className="edit-button"
          onClick={(e) => {
            e.stopPropagation();
            if (type === 'test') {
              window.location.href = `/edit-test/${data.id}`;
            } else if (onEdit) {
              onEdit();
            }
            onClose();
          }}
          style={{
            position: 'absolute',
            top: '15px',
            right: '50px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '20px',
            color: '#555'
          }}
        >
          <FaEdit />
        </button>
        
        <h2 className="modal-title">
          {type === 'group' ? 'Детали группы' : 'Детали теста'}
        </h2>
        
        <div className="modal-body">
          {type === 'group' ? (
            <>
              <div className="modal-section">
                <h3>{data.name}</h3>
                <p><strong>Описание:</strong> {data.description || 'Описание отсутствует'}</p>
              </div>
              
              <div className="modal-section">
                <p><strong>Дата создания:</strong> {data.date_create || 'Дата отсутствует'}</p>
              </div>
              
              <div className="modal-section">
                <h4>Участники ({data.users.length})</h4>
                <div className="participants-list">
                  {data.users.map(user => (
                    <div key={user.user_id} className="participant-item">
                      <div>{user.user_name}</div>
                      <div className="participant-email">{user.user_mail}</div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="modal-section">
                <h3>{data.name}</h3>
                <p><strong>Описание:</strong> {data.description || 'Описание отсутствует'}</p>
              </div>
              
              <div className="modal-section">
                <p><strong>Количество вопросов:</strong> {data.questions.length}</p>
                <p><strong>Дата создания:</strong> {data.date_created || 'Дата отсутствует'}</p>
              </div>
              
              <div className="modal-section">
                <h4>Типы вопросов</h4>
                <div className="types-list">
                  {data.question_types.map((type, index) => (
                    <span key={index} className="type-tag">{type}</span>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailModal;